import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import LiteratureCoverLetter from '../../../LiteratureCoverLetter';
import { getDeviationTitle, styleFromWidthHeight } from '../../_helpers';
import ExcerptRenderer from '../../../TextRenderer/ExcerptRenderer';
import styles from './Literature.scss';
import stylesBrowseV2 from './Literature.browsev2_thumbs.scss';
var typeMap = {
    ANTFART: 'antfart',
    NANO: 'nano',
    SMALL: 'small',
    MEDIUM: 'medium',
    BIG: 'big', // CR40 - Literature Box
};
// not sure about the correct approach, I used the comparison with the area, as there were no breakpoints for height and width
export var typeSizeMap = {
    ANTFART: 66,
    NANO: 150,
    SMALL: 214,
    MEDIUM: 250,
    BIG: 280,
};
function getTypeBasedOnSize(size) {
    if (size <= typeSizeMap.ANTFART) {
        return typeMap.ANTFART;
    }
    if (size <= typeSizeMap.NANO) {
        return typeMap.NANO;
    }
    if (size <= typeSizeMap.SMALL) {
        return typeMap.SMALL;
    }
    if (size > typeSizeMap.BIG) {
        return typeMap.BIG;
    }
    return typeMap.MEDIUM;
}
var LiteratureDumbView = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height, useTextlessMode = _a.useTextlessMode, _b = _a.responsive, responsive = _b === void 0 ? true : _b, className = _a.className, coverLetterClassName = _a.coverLetterClassName, ariaHidden = _a["aria-hidden"];
    var isBrowseV2 = useFlag('browsev2_thumbs');
    var s = isBrowseV2 ? stylesBrowseV2 : styles;
    var t = useTranslation().t;
    var type = getTypeBasedOnSize(height);
    var deviationTitle = getDeviationTitle(deviation);
    var style = styleFromWidthHeight({ width: width, height: height }, responsive);
    var isBigEnough = (style.height || 0) > typeSizeMap.ANTFART;
    return (React.createElement(Section, { className: classnames(s['root'], s[type], className), style: style, "aria-hidden": ariaHidden },
        React.createElement(LiteratureCoverLetter, { title: deviationTitle, isBigEnough: isBigEnough, className: coverLetterClassName }),
        !useTextlessMode && (React.createElement(React.Fragment, null,
            isBrowseV2 && (React.createElement("div", { className: s['tag'] }, t('deviationview.literature.tag'))),
            React.createElement(Heading, { className: s['title'] }, deviationTitle),
            React.createElement(ExcerptRenderer, { className: s['text-content'], textContent: deviation.textContent, htmlExcerptLegacy: true })))));
};
LiteratureDumbView.displayName = 'LiteratureDumbView';
export default LiteratureDumbView;
//# sourceMappingURL=Literature.js.map